import { useState, useEffect } from 'react';
import { unlockRewards } from '../flows/shared/summit.utils';
/* import { getTier, getNextTier, getTierMinimum, getAmountToNextTier, unlockRewards } from '../flows/shared/summit.utils'; */
/* import { isWithinNextTierRange } from '../flows/shared/summit.testers'; */

/**
 * NOTE: Much of this file is commented out as SMP reqs have changed,
 * but keeping for now as it may be used in the near future.
 */

/* These args get passed in from appState thru SummitRewards 
  into RewardsContext constructs.
  initialTotalAmount should be a number (investment amount) 
  initialTier should be string (one of the tierTypes
  found in src/flows/shared/summit.utils.ts)
  initialHouseholdBalance should be a number (from service) */

/* Any other necessary SMP-related session data that persists
  across pages in a flow could be stored in this file */

export default ({
  initialTotalAmount,
  initialTier,
  initialHouseholdBalance
}) => {
  const [totalAmount /* , setTotalAmount */] = useState(initialTotalAmount);
  const [currentTier /* , setCurrentTier */] = useState(initialTier);
  const [currentHouseholdBalance /* , setHouseholdBalance */] = useState(
    initialHouseholdBalance
  );

  const [rewardsAvailable, setRewardsAvailable] = useState(unlockRewards(0));

  useEffect(() => {
    const rewards = unlockRewards(currentTier);
    setRewardsAvailable(rewards);
  }, [currentTier]);

  /* this could be null if totalAmount > $1M, there is no next tier */
  /* const nextTier = getNextTier(totalAmount);

  const nextTierMinimum = getTierMinimum(nextTier);
  
  const amountToNextTier = getAmountToNextTier(totalAmount);
  
  const isWithinRangeOfNextTier = Boolean(nextTier) ? isWithinNextTierRange(nextTier, amountToNextTier) : false; */

  return {
    totalAmount,
    currentTier,
    currentHouseholdBalance,
    rewardsAvailable /* ,
    nextTier,
    nextTierMinimum,
    amountToNextTier,
    isWithinRangeOfNextTier */
  };
};
